module.exports = require("./ga-IE");